module.exports = __webpack_public_path__ + "img/location.4e84d820.svg";